import { Link } from "react-router-dom";

const footerSections = [
  {
    title: "Marketplace",
    links: [
      { label: "All listings", href: "/marketplace" },
      { label: "Products", href: "/marketplace/products" },
      { label: "Services", href: "/marketplace/services" },
    ],
  },
  {
    title: "Engage",
    links: [
      { label: "Events", href: "/events" },
      { label: "ESG Readiness Index", href: "/esg" },
      { label: "Membership", href: "/register" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About", href: "/about" },
      { label: "Chapters", href: "/chapters" },
      { label: "Partners", href: "/partners" },
      { label: "Contact", href: "/contact" },
      { label: "Sign in", href: "/login" },
    ],
  },
];

const Footer = () => {
  return (
    <footer className="bg-navy text-navy-foreground">
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-4 lg:col-span-1 mb-4 lg:mb-0">
            <p className="font-semibold text-sm mb-3">Aamecc digital</p>
            <p className="text-sm text-white leading-relaxed max-w-xs">
              The Africa, Asia and Middle East Chamber of Commerce digital platform — verified members, marketplace, events and ESG.
            </p>
          </div>

          {footerSections.map((section) => (
            <div key={section.title}>
              <h4 className="text-xs font-semibold uppercase tracking-wider text-white mb-4">
                {section.title}
              </h4>
              <ul className="space-y-2">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-white hover:text-gold transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-navy-light flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-white">
            © {new Date().getFullYear()} Aamecc digital. All rights reserved.
          </p>
          <div className="flex flex-wrap gap-6">
            <a
              href="https://aamecc.org/terms-conditions/"
              target="_blank"
              rel="noreferrer"
              className="text-xs text-white hover:text-gold transition-colors"
            >
              Terms &amp; Conditions
            </a>
            <a
              href="https://aamecc.org/cookie-policy/"
              target="_blank"
              rel="noreferrer"
              className="text-xs text-white hover:text-gold transition-colors"
            >
              Cookie Policy
            </a>
            <a
              href="https://aamecc.org/data-protection-website-disclaimer/"
              target="_blank"
              rel="noreferrer"
              className="text-xs text-white hover:text-gold transition-colors"
            >
              Data Protection &amp; Disclaimer
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
